module.exports = __webpack_public_path__ + "static/icon_grubhub-c01c127568bded63a7641e8aff640563.png";